import styled from 'styled-components';

export const ProductReviewsContainer = styled.div`
    text-align: center;
`;

export const PreviousPage = styled.p`
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    margin-top: 100px;
    color: black;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;

    img {
        width: 32px;
    }

    @media screen and (max-width: 600px) {
        margin-top: 90px;
        margin-bottom: 10px;
    }
`;


export const ProductReviewsTitle = styled.h1`
    font-family: 'Poppins';
    font-weight: 700;
    font-size: 38px;
    color: rgb(14, 69, 116);
`;

export const HistoryRoutes = styled.div`
    text-align: left;
    display: flex;

    @media screen and (max-width: 600px) {
        flex-wrap: wrap;
    }
`

export const HistoryRoute = styled.p`
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
    display: inline-flex;
    align-items: center; 

    img {
        margin: 0 10px;
        height: 14px;
    }

    :last-child {
        font-weight: 700;
        color: #96A83B;
    }
`